/* eslint-disable react/prop-types */
import React from "react"
import { RouteComponentProps } from "@reach/router"
import { DocumentTitleOverride } from "@shared/primitive-components"
import { IFrame } from "./iframe"
import { usePolicyAndFleet } from "../contexts"

export const Trips: React.FC<RouteComponentProps> = () => {
  const { policy } = usePolicyAndFleet()

  return (
    <>
      <DocumentTitleOverride>Flock Motor | Safety Insights - Trips</DocumentTitleOverride>
      <IFrame path={`policies/${policy.id}/trips`} />
    </>
  )
}
